module.exports = "pegasus/assets/themelp1/scratch/102.png";